"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QueryParamKeys = void 0;
var QueryParamKeys;
(function (QueryParamKeys) {
    QueryParamKeys["PAGE"] = "page";
    QueryParamKeys["LIMIT"] = "limit";
    QueryParamKeys["STATUS"] = "status";
    QueryParamKeys["CREATED_FROM"] = "from";
    QueryParamKeys["CREATED_TO"] = "to";
    QueryParamKeys["DELETED_FROM"] = "deletedFrom";
    QueryParamKeys["DELETED_TO"] = "deletedTo";
    QueryParamKeys["DUE_FROM"] = "dueFrom";
    QueryParamKeys["DUE_TO"] = "dueTo";
    QueryParamKeys["AMOUNT_FROM"] = "amountFrom";
    QueryParamKeys["AMOUNT_TO"] = "amountTo";
    QueryParamKeys["SEARCH_KEYWORD"] = "searchKeyword";
    QueryParamKeys["SORT_KEY"] = "sort";
    QueryParamKeys["SORT_DIRECTION"] = "sortDirection";
    QueryParamKeys["FILTER_FIELD"] = "filter";
    QueryParamKeys["FILTER_VALUE"] = "filterValue";
    QueryParamKeys["COMPLETED_FROM"] = "completedFrom";
    QueryParamKeys["COMPLETED_TO"] = "completedTo";
    QueryParamKeys["DIRECTION"] = "direction";
    QueryParamKeys["CREATED_BY"] = "createdBy";
    QueryParamKeys["ROLE"] = "role";
    QueryParamKeys["SUPPLIER"] = "supplier";
    QueryParamKeys["CUSTOMER"] = "customer";
    QueryParamKeys["CATEGORY"] = "category";
    QueryParamKeys["BRAND"] = "brand";
    QueryParamKeys["TYPE"] = "type";
    QueryParamKeys["PAYMENT_PROVIDER"] = "paymentProvider";
    QueryParamKeys["INVETORY_STATUS"] = "inventoryStatus";
    QueryParamKeys["PRICE_FROM"] = "priceFrom";
    QueryParamKeys["PRICE_TO"] = "priceTo";
    QueryParamKeys["SOLD_TO"] = "soldTo";
    QueryParamKeys["SOLD_FROM"] = "soldFrom";
    QueryParamKeys["QTY_TO"] = "qtyTo";
    QueryParamKeys["QTY_FROM"] = "qtyFrom";
    QueryParamKeys["PUBLISHED_FROM"] = "publishedFrom";
    QueryParamKeys["PUBLISHED_TO"] = "publishedTo";
    QueryParamKeys["REFERENCE"] = "reference";
    QueryParamKeys["TOTAL_AMOUNT_TO"] = "totalAmountTo";
    QueryParamKeys["TOTAL_AMOUNT_FROM"] = "totalAmountFrom";
    QueryParamKeys["CARRIER"] = "carrier";
    QueryParamKeys["PICKER"] = "picker";
    QueryParamKeys["WAREHOUSE"] = "warehouse";
    QueryParamKeys["LOCATION"] = "location";
    QueryParamKeys["MANIFEST"] = "manifest";
    QueryParamKeys["SHIPMENT"] = "shipment";
    QueryParamKeys["PICKED_AT_FROM"] = "pickedAtFrom";
    QueryParamKeys["PICKED_AT_TO"] = "pickedAtTo";
    QueryParamKeys["SHIPDATE_FROM"] = "shipDateFrom";
    QueryParamKeys["SHIPDATE_TO"] = "shipDateTo";
    QueryParamKeys["PICKING_STATUS"] = "pickingStatus";
})(QueryParamKeys = exports.QueryParamKeys || (exports.QueryParamKeys = {}));
